// Color palette constants — HARDER & HIGHER CONTRAST VARIANT
export const COLORS = {
  // Primary colors — hard, bold, high-contrast
  BLACK: "#000000", // Absolute black
  DARK_BLUE: "#0B1D51", // Very dark navy
  ORANGE: "#FF6700", // Fiery vivid orange
  LIGHT_GRAY: "#DADADA", // Crisp concrete gray
  WHITE: "#FFFFFF", // Bright white

  // Semantic color mappings
  PRIMARY: "#000000",
  SECONDARY: "#0B1D51",
  ACCENT: "#FF6700",
  BACKGROUND: "#FFFFFF",
  SURFACE: "#DADADA",
  TEXT_PRIMARY: "#000000",
  TEXT_SECONDARY: "#0B1D51",
  BORDER: "#DADADA",

  // Dark mode variants
  DARK_BACKGROUND: "#000000",
  DARK_SURFACE: "#0B1D51",
  DARK_TEXT_PRIMARY: "#FFFFFF",
  DARK_TEXT_SECONDARY: "#DADADA",
  DARK_BORDER: "#0B1D51",

  // Transparent variants
  BLACK_10: "rgba(0, 0, 0, 0.1)",
  BLACK_15: "rgba(0, 0, 0, 0.15)",
  BLACK_20: "rgba(0, 0, 0, 0.2)",
  BLACK_30: "rgba(0, 0, 0, 0.3)",
  BLACK_40: "rgba(0, 0, 0, 0.4)",
  BLACK_50: "rgba(0, 0, 0, 0.5)",
  BLACK_60: "rgba(0, 0, 0, 0.6)",
  BLACK_70: "rgba(0, 0, 0, 0.7)",
  BLACK_80: "rgba(0, 0, 0, 0.8)",
  BLACK_90: "rgba(0, 0, 0, 0.9)",

  WHITE_10: "rgba(255, 255, 255, 0.1)",
  WHITE_15: "rgba(255, 255, 255, 0.15)",
  WHITE_20: "rgba(255, 255, 255, 0.2)",
  WHITE_30: "rgba(255, 255, 255, 0.3)",
  WHITE_40: "rgba(255, 255, 255, 0.4)",
  WHITE_50: "rgba(255, 255, 255, 0.5)",
  WHITE_60: "rgba(255, 255, 255, 0.6)",
  WHITE_70: "rgba(255, 255, 255, 0.7)",
  WHITE_80: "rgba(255, 255, 255, 0.8)",
  WHITE_90: "rgba(255, 255, 255, 0.9)",

  ORANGE_10: "rgba(255, 103, 0, 0.1)",
  ORANGE_15: "rgba(255, 103, 0, 0.15)",
  ORANGE_20: "rgba(255, 103, 0, 0.2)",
  ORANGE_30: "rgba(255, 103, 0, 0.3)",
  ORANGE_40: "rgba(255, 103, 0, 0.4)",
  ORANGE_50: "rgba(255, 103, 0, 0.5)",
  ORANGE_60: "rgba(255, 103, 0, 0.6)",
  ORANGE_70: "rgba(255, 103, 0, 0.7)",
  ORANGE_80: "rgba(255, 103, 0, 0.8)",
  ORANGE_90: "rgba(255, 103, 0, 0.9)",

  DARK_BLUE_10: "rgba(11, 29, 81, 0.1)",
  DARK_BLUE_15: "rgba(11, 29, 81, 0.15)",
  DARK_BLUE_20: "rgba(11, 29, 81, 0.2)",
  DARK_BLUE_30: "rgba(11, 29, 81, 0.3)",
  DARK_BLUE_40: "rgba(11, 29, 81, 0.4)",
  DARK_BLUE_50: "rgba(11, 29, 81, 0.5)",
  DARK_BLUE_60: "rgba(11, 29, 81, 0.6)",
  DARK_BLUE_70: "rgba(11, 29, 81, 0.7)",
  DARK_BLUE_80: "rgba(11, 29, 81, 0.8)",
  DARK_BLUE_90: "rgba(11, 29, 81, 0.9)",

  LIGHT_GRAY_10: "rgba(218, 218, 218, 0.1)",
  LIGHT_GRAY_15: "rgba(218, 218, 218, 0.15)",
  LIGHT_GRAY_20: "rgba(218, 218, 218, 0.2)",
  LIGHT_GRAY_30: "rgba(218, 218, 218, 0.3)",
  LIGHT_GRAY_40: "rgba(218, 218, 218, 0.4)",
  LIGHT_GRAY_50: "rgba(218, 218, 218, 0.5)",
  LIGHT_GRAY_60: "rgba(218, 218, 218, 0.6)",
  LIGHT_GRAY_70: "rgba(218, 218, 218, 0.7)",
  LIGHT_GRAY_80: "rgba(218, 218, 218, 0.8)",
  LIGHT_GRAY_90: "rgba(218, 218, 218, 0.9)",
};

// Helper function to get theme-aware colors
export const getThemeColor = (isDark, lightColor, darkColor) => {
  return isDark ? darkColor : lightColor;
};

// Helper function to get color with opacity
export const getColorWithOpacity = (color, opacity) => {
  return color.replace(")", `, ${opacity})`).replace("rgb", "rgba");
};

export default COLORS;
